export default function errorReducer(_, action) {
    const { error } = action;
    return {
        error: error || null,
    };
}
